/* Draft Store only — display arrival using SHIPPING TRANSIT ONLY.
   Current Shopify shipping-profile snapshot (2026-08-20):
   US/GB max transit = 8 business days; other configured destinations = 10 business days.
   NOTE: storefront theme code cannot read merchant Admin shipping-profile transit times directly.
*/
(() => {
  'use strict';

  const SHIPPING_MAX_BUSINESS_DAYS = {
    US: 8,
    GB: 8
  };
  const DEFAULT_MAX_BUSINESS_DAYS = 10;

  function currentCountryCode() {
    const selectors = [
      '.pz-delivery-country-form select[name="country_code"]',
      '.pz-delivery-card select[name="country_code"]',
      '#PzInlineDeliveryCountry',
      '#PzProductCountryForm select[name="country_code"]',
      'form[action*="/localization"] select[name="country_code"]'
    ];

    for (const selector of selectors) {
      const field = document.querySelector(selector);
      if (field && field.value) return String(field.value).toUpperCase();
    }

    if (window.Shopify && window.Shopify.country) {
      return String(window.Shopify.country).toUpperCase();
    }

    return 'CA';
  }

  function addBusinessDays(start, count) {
    const result = new Date(start.getFullYear(), start.getMonth(), start.getDate());
    let added = 0;
    while (added < count) {
      result.setDate(result.getDate() + 1);
      const day = result.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return result;
  }

  function formatArrivalDate(date) {
    const language = document.documentElement.lang || 'en-US';
    try {
      return new Intl.DateTimeFormat(language, { month: 'short', day: 'numeric' }).format(date);
    } catch (_) {
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }
  }

  function updateArrival() {
    const pill = document.querySelector('#MainContent .pz-delivery-card .pz-arrival-pill');
    if (!pill) return false;

    const country = currentCountryCode();
    const businessDays = SHIPPING_MAX_BUSINESS_DAYS[country] || DEFAULT_MAX_BUSINESS_DAYS;
    const arrivalDate = addBusinessDays(new Date(), businessDays);
    const formatted = formatArrivalDate(arrivalDate);

    pill.classList.add('pz-arrival-info');
    pill.setAttribute('aria-label', `Estimated shipping arrival by ${formatted}`);
    pill.innerHTML = `<span class="pz-arrival-plane" aria-hidden="true">✈️</span><span class="pz-arrival-label">Arrive by <strong>${formatted}</strong></span>`;

    const details = pill.closest('details.pz-arrival-details');
    if (details) details.removeAttribute('open');
    return true;
  }

  function refreshSoon() {
    updateArrival();
    window.setTimeout(updateArrival, 250);
    window.setTimeout(updateArrival, 900);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshSoon, { once: true });
  } else {
    refreshSoon();
  }

  window.addEventListener('pageshow', refreshSoon);
  document.addEventListener('change', (event) => {
    if (event.target && event.target.matches('select[name="country_code"]')) {
      window.setTimeout(updateArrival, 0);
    }
  });
  document.addEventListener('variant:change', refreshSoon);
})();
